<div class="mx-auto max-w-screen-md">
	@if (isReadMore) {
		<vp-read-more>
			<ng-container [ngTemplateOutlet]="markdown" />
		</vp-read-more>
	} @else {
		<ng-container [ngTemplateOutlet]="markdown" />
	}
</div>

<ng-template #markdown>
	<markdown
		[class]="listStyle"
		[data]="content"
		[editableInStoryblok]="_editable()"
		class="markdown"
		data-test-class="markdown"
	/>
</ng-template>
